module.exports = __webpack_public_path__ + "files/87020025c705c8cf58a34122d60b16a8.png";